import React from "react";
import { useIntl } from "react-intl";

import TableHeader from "../../app/generic/tableHeader";

export default function Header({ edit }) {
  const intl = useIntl();
  return (
    <TableHeader
      title={
        edit
          ? intl.formatMessage({
              id: "document.edit",
              defaultMessage: "Editace dokumentu",
            })
          : intl.formatMessage({
              id: "document.new",
              defaultMessage: "Nový dokument",
            })
      }
    />
  );
}
